import React, {FunctionComponent} from 'react';
import ReactDOM from 'react-dom';

import './LoadingSpinner.less';
import {LoadingIcon} from "../loading-icon/LoadingIcon";
import {LoadingStyle} from "../../../reducers/loading.reducer.types";

interface LoadingSpinnerProps{
	style: LoadingStyle
}

const domNode = document.getElementById('loading-spinner');

export const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = ({style = LoadingStyle.TRANSPARENT}) => {
	return ReactDOM.createPortal(
		<div className={`loading-spinner ${style === LoadingStyle.OPAQUE ? 'loading-spinner--opaque' : 'loading-spinner--transparent'}`}>
			<LoadingIcon/>
		</div>,
		domNode
	);
};
